import type { CityConfig } from "../city-template/types";

export const salisburyConfig: CityConfig = {
  city: "Salisbury",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "salisbury",
  route: "/salisbury",
  title: "Emergency Passport Salisbury, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Salisbury, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Rowan County and the north Charlotte metro area. Get your passport fast with Fast Passport Center.",
  h1: "Emergency & Expedited Passport Services in Salisbury, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Salisbury and Rowan County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Salisbury%20North%20Carolina%20historic%20downtown%20main%20street%20at%20golden%20hour%20with%20beautiful%20vintage%20architecture%20and%20classic%20American%20storefronts%2C%20tree-lined%20sidewalks%20with%20Southern%20charm%2C%20warm%20sunset%20light%20over%20Rowan%20County%2C%20green%20trees%20and%20well-maintained%20buildings%2C%20historic%20courthouse%20district%20visible%2C%20professional%20cityscape%20photography%20with%20warm%20earthy%20tones%20and%20small%20town%20Southern%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=salisbury-hero-nc-001&orientation=landscape",
  heroImageAlt: "Salisbury North Carolina historic downtown main street with vintage architecture and warm sunset light",
  geoPosition: "35.6709;-80.4742",
  geoPlacename: "Salisbury, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 220 miles from Salisbury via I-85",
  },
  nearbyCitiesZips: [
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Statesville", zips: "28625, 28677, 28687" },
    { name: "Lexington", zips: "27292, 27293, 27295" },
    { name: "Thomasville", zips: "27360, 27361" },
    { name: "High Point", zips: "27260, 27261, 27262, 27263, 27265" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "Albemarle", zips: "28001, 28002" },
    { name: "China Grove", zips: "28023" },
    { name: "Rockwell", zips: "28138" },
    { name: "Landis", zips: "28088" },
    { name: "Midland", zips: "28107" },
    { name: "Richfield", zips: "28137" },
    { name: "Spencer", zips: "28159" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Cornelius", zips: "28031" },
    { name: "Harrisburg", zips: "28075" },
    { name: "Mount Pleasant", zips: "28124" },
    { name: "Stanfield", zips: "28163" },
    { name: "Locust", zips: "28097" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Rowan County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Rowan County Hub", desc: "Serving Salisbury, Kannapolis, Concord, and the north Charlotte metro area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Fast passport renewal in Kannapolis, NC", route: "/kannapolis" },
    { name: "Emergency passport help in Concord, NC", route: "/concord-nc" },
    { name: "Urgent passport services in Statesville, NC", route: "/statesville" },
    { name: "Same-day passport help in Mooresville, NC", route: "/mooresville" },
    { name: "Passport courier services in Winston-Salem, NC", route: "/winston-salem" },
    { name: "Passport courier services in Greensboro, NC", route: "/greensboro" },
    { name: "Fast passport renewal in Hickory, NC", route: "/hickory" },
    { name: "Passport courier services in Huntersville, NC", route: "/huntersville" },
    { name: "Passport courier services in Davidson, NC", route: "/davidson" },
    { name: "Expedited passport services in Asheboro, NC", route: "/asheboro" },
    { name: "Passport courier services in Thomasville, NC", route: "/thomasville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Salisbury remotely via secure courier. We do not have a walk-in office in Salisbury — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Rowan County and the north Charlotte metro area travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Rowan County and the north Charlotte metropolitan region",
  serviceAreaIntro: "From the historic downtown streets of Salisbury to the suburban neighborhoods of Kannapolis, from the quiet communities of China Grove and Rockwell to the bustling corridors of Concord and Charlotte, from the Piedmont towns of Lexington and Thomasville to the growing communities of Albemarle and Asheboro — Fast Passport Center serves the entire Salisbury region. We regularly help travelers from Rowan County, Cabarrus County, and the north Charlotte metro area get their expedited passports fast.",
  nearbyCitiesIntro: "We serve all Salisbury neighborhoods and the surrounding Rowan County and north Charlotte area including Kannapolis, Concord, Charlotte, Mooresville, Statesville, Lexington, Thomasville, High Point, Winston-Salem, Greensboro, Asheboro, Albemarle, China Grove, Rockwell, Landis, Midland, Richfield, Spencer, Huntersville, Davidson, Cornelius, Harrisburg, Mount Pleasant, Stanfield, and Locust. If you are anywhere in Rowan County, Cabarrus County, or the north Charlotte metropolitan area, we have you covered for fast passport and expedited passport services.",
  howItWorksIntro: "Most Salisbury travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Salisbury travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays in getting an expedited passport.",
  testimonialsIntro: "Salisbury and Rowan County travelers trust us when their departure is days away. Here is what some of them have to say about our emergency passport and fast passport services.",
  faqIntro: "Have questions about expedited passports in Salisbury? Here are the most common ones we hear from Rowan County and north Charlotte travelers about emergency passport and fast passport processing.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Salisbury international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia H.",
      location: "Salisbury, NC",
      rating: 5,
      text: "My passport expired 4 days before our family trip to Mexico. Fast Passport Center had my renewal ready in 30 hours. I never left Salisbury. The expedited passport service was outstanding.",
      service: "Passport Renewal",
    },
    {
      name: "Michael R.",
      location: "Kannapolis, NC",
      rating: 5,
      text: "Emergency passport for a business trip to Germany. Got it in 26 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Their fast passport service is incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Susan L.",
      location: "Concord, NC",
      rating: 5,
      text: "First passport for my 10-year-old before our Europe trip. Fast Passport Center walked us through every step and had her passport in 4 days. So easy for Cabarrus County families.",
      service: "Child Passport",
    },
    {
      name: "Robert T.",
      location: "China Grove, NC",
      rating: 5,
      text: "Lost my passport 3 days before a cruise. Fast Passport Center had a replacement in my hands in 28 hours. Their expedited passport service across Rowan County is unmatched.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "salisbury-1",
      name: "Salisbury Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "620 W Innes St",
      city: "Salisbury",
      state: "NC",
      zip: "28144",
      phone: "(704) 636-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Salisbury facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-2",
      name: "Kannapolis Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1040 Dale Earnhardt Blvd",
      city: "Kannapolis",
      state: "NC",
      zip: "28083",
      phone: "(704) 938-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles west of Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cabarrus County and western Rowan County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-3",
      name: "Concord Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "80 Davidson Hwy",
      city: "Concord",
      state: "NC",
      zip: "28027",
      phone: "(704) 786-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Concord and Harrisburg. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-4",
      name: "Mooresville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E Plaza Dr",
      city: "Mooresville",
      state: "NC",
      zip: "28115",
      phone: "(704) 663-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southwest of Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lake Norman area and Iredell County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-5",
      name: "Rowan County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "210 N Main St",
      city: "Salisbury",
      state: "NC",
      zip: "28144",
      phone: "(704) 638-3000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Salisbury",
      website: "https://www.rowancountync.gov/",
      websiteLabel: "Rowan County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "salisbury-6",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles south of Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Salisbury photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Rowan County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Salisbury applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Rowan County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Salisbury travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Salisbury." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Salisbury address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Salisbury before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Salisbury for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I get an expedited passport in Salisbury?", a: "Fast Passport Center offers expedited passport services in Salisbury in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day standard expedited option provides the best value. Both options include full document review and a dedicated agent to ensure your fast passport is processed correctly." },
    { q: "What is the closest passport agency to Salisbury?", a: "The nearest regional passport agency to Salisbury is the Atlanta Passport Agency, approximately 220 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Salisbury without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Salisbury?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Salisbury — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Rowan County and north Charlotte residents." },
    { q: "Do you serve the entire Rowan County area for expedited passports?", a: "Absolutely. Fast Passport Center provides expedited passport services throughout the entire Rowan County and north Charlotte area including Salisbury, Kannapolis, Concord, Charlotte, Mooresville, Statesville, Lexington, Thomasville, High Point, Winston-Salem, Greensboro, Asheboro, Albemarle, China Grove, Rockwell, Landis, Midland, Richfield, Spencer, Huntersville, Davidson, Cornelius, Harrisburg, Mount Pleasant, Stanfield, and Locust. Our courier service works seamlessly from any address in Rowan County, Cabarrus County, and surrounding areas." },
    { q: "Can I expedite a child passport in Salisbury?", a: "Yes. Fast Passport Center expedites child passports in Salisbury for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Rowan County families through the entire fast passport process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Salisbury with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency for an expedited passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change. This is how we deliver fast passport and expedited passport services to Salisbury without the long drive." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Salisbury", address: "1011 E Innes St, Salisbury, NC 28144", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Salisbury", address: "1121 E Innes St, Salisbury, NC 28144", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Salisbury", address: "323 S Arlington St, Salisbury, NC 28144", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Kannapolis", address: "1040 Dale Earnhardt Blvd, Kannapolis, NC 28083", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Concord", address: "3480 Concord Pkwy S, Concord, NC 28027", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Mooresville", address: "569 River Hwy, Mooresville, NC 28117", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Statesville", address: "1505 E Broad St, Statesville, NC 28677", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Salisbury",
      address: "1415 W Innes St, Salisbury, NC 28144",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Kannapolis",
      address: "200 N Cannon Blvd, Kannapolis, NC 28083",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Concord",
      address: "6601 E Harris Blvd, Charlotte, NC 28215",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cabarrus County and north Charlotte area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Statesville",
      address: "1055 Glenway Dr, Statesville, NC 28625",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Iredell County and western Rowan area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "45 miles south of Salisbury",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. About 50 minutes from Salisbury.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "55 miles northeast of Salisbury",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for Piedmont Triad travelers. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "130 miles east of Salisbury",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Rowan County Register of Deeds", url: "https://www.rowancountync.gov/268/Register-of-Deeds", description: "Birth, death, and marriage records for Rowan County" },
    { name: "Rowan County Superior Court", url: "https://www.nccourts.gov/locations/rowan-county", description: "Divorce records and court documents for Rowan County" },
  ],
};